import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./ArchiveModal.module.scss";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  children: React.ReactNode;
};
const ArchiveModal: React.FC<Props> = ({ isOpen, handleClose, children }) => {
  return (
    <div
      className={`${styles["archive-modal"]} ${isOpen ? styles["open"] : ""}`}
    >
      <button onClick={handleClose} className={styles["modal-close"]}>
        <FontAwesomeIcon icon={["fal", "times"]} />
      </button>
      {children}
    </div>
  );
};

export default ArchiveModal;
